import React from "react";
import { Box, Typography, Paper, Grid, Button } from "@mui/material";
import "./welcome.css"; // Custom CSS for additional styling

const Welcome = ({ nextStep }) => {
  return (
    <Box className='welcome-container'>
      <Paper className='welcome-info-container'>
        <Grid container mt={3}>
          <Grid item sm={8} lg={8}>
            <Typography
              variant='h4'
              className='welcome-title'
              sx={{ fontSize: "43px", fontFamily: "'Love Ya Like A Sister', cursive" }}
            >
              Welcome
            </Typography>

            {/* First paragraph */}
            <Typography sx={{ color: "#7f8c8d", fontSize: "14px", fontFamily: "'Shantell Sans', sans-serif" }} mt={3}>
              Hi, I'm Chantelle, I'm the <strong>Manager</strong> at Little Norway. You will see me around the house
              between Mondays and Fridays. There may be times when I will come in over the weekends too.
            </Typography>

            {/* Second paragraph */}
            <Typography sx={{ color: "#7f8c8d", fontSize: "14px", fontFamily: "'Shantell Sans', sans-serif" }} mt={2}>
              I have looked after young people for over 4 years and will try and support you as much as possible. There
              are times when I may be out of the office, but I will try and see you either <em>before</em> or{" "}
              <em>afterschool</em>. I want you to feel safe at Little Norway and enjoy your time here.
            </Typography>

            {/* Third paragraph */}
            <Typography sx={{ color: "#7f8c8d", fontSize: "14px", fontFamily: "'Shantell Sans', sans-serif" }} mt={2}>
              There are a group of adults at Little Norway that take turns to look after you. There will always be three
              adults in the house including nighttime where they will sleep over in the adult sleep room.
            </Typography>

            {/* Fourth paragraph */}
            <Typography sx={{ color: "#7f8c8d", fontSize: "14px", fontFamily: "'Shantell Sans', sans-serif" }} mt={2}>
              When you first move into the home, you will be given two Keyworkers, although you can speak to any adult
              in the home. Your keyworkers will be the main two people you can go to with any problems or questions you
              may have.
            </Typography>

            {/* Closing signature */}
            <Typography sx={{ color: "#7f8c8d", fontSize: "14px", fontFamily: "'Shantell Sans', sans-serif" }} mt={3}>
              Welcome again,
              <br />
              <strong>Chantelle</strong>
            </Typography>
          </Grid>
          <Grid item sm={4} lg={4}>
            <Box>
              <img src='./CYPImages/happywoman.png' alt='Child illustration' className='women-image' />
            </Box>
          </Grid>
        </Grid>

        <Box mt={3}>
          <Grid item xs={12}>
            <div className='submit-button-container'>
              <Button type='submit' variant='contained' color='primary' className='submit-button' onClick={nextStep}>
                Next
              </Button>
            </div>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default Welcome;
